import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from "@angular/forms";
import { PropertyMap } from "../../../../../../../models/entity.model";
import { ParserPropertyModel } from "../parser.model";

@Component({
    selector: 'entity-property',
    templateUrl: './entity-property.component.html',
    styleUrls: ['./entity-property.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EntityPropertyComponent implements OnInit {

    form: FormGroup = new FormGroup({});
    @Input() index: number = 0;
    @Input() predicate: string = "";
    @Input() property: PropertyMap;

    @Output() propertyAdded: EventEmitter<ParserPropertyModel> = new EventEmitter<ParserPropertyModel>();

    constructor(private builder: FormBuilder) { }

    ngOnInit() {
        this.buildForm();
    }

    addProperty(propertyName: string) {
        const name: string = (this.predicate.length > 0 && this.predicate != 'object')
            ? `${this.predicate}.${propertyName}`
            : propertyName;
        let propertyType = this.property.propertyType;
        if (Array.isArray(propertyType)) {
            var type = null;
            var format = null;
            for (let p = 0; p < propertyType.length; p++) {
				if (propertyType[p].toString != null && propertyType[p].toString() != propertyType[p]) {
					var map = <PropertyMap>propertyType[p];
					if (map.propertyName === "type") {
						type = map.propertyType;
					}
					else if (map.propertyName === "format") {
						format = map.propertyFormat;
					}
				} else {
					var map = <PropertyMap>propertyType[p];
					type = map.propertyType;
					format = map.propertyFormat;
				}
                if (type != null && format != null) break;
            }
            propertyType = (format != null && format.length > 0) ? format : type;            
        }

        let required: boolean = false;
        let api: boolean = false;
        if (this.form != null) {
            const requiredCtrl = this.form.get("require");
            if (requiredCtrl != null) {
                required = <boolean>requiredCtrl.value;
            }
            const apiCtrl = this.form.get("api");
            if (apiCtrl != null) {
                api = <boolean>apiCtrl.value;
            }
        }

        const model = {
            propertyName: name,
            propertyType: propertyType,
            apiValidation: api,
            requiredValidation: required
        } as ParserPropertyModel;
        this.modelCreated(model);
    }

    buildForm(): void {
        this.form = this.builder.group({
            require: [false, []],
            api: [false, []]
        });
    }

    isObjectArrayProperty(property: string | PropertyMap[] | Array<string | PropertyMap[]>, min: number = 1): boolean {
        if (!Array.isArray(property) || property.length === 0) return false;
        var propAsArray = <any[]>property;
        if (propAsArray.length > min) return true;
        return this.isObjectArrayProperty(propAsArray[0].propertyType);
    }

    modelCreated(model: ParserPropertyModel): void {
        if (this.predicate.length > 0 && this.predicate != 'object' && model.propertyName.startsWith(this.predicate) === false) {
            model.propertyName = `${this.predicate}.${model.propertyName}`;
        }
        this.propertyAdded.emit(model);
    }

}
